module.exports = __webpack_public_path__ + "img/gyant_grey_ba_list.2a79f47e.jpg";